import { StoreState } from '../../../store/store.interface';

export const getInstructorSampleOrdersData = (state: StoreState) => state.myAccountState.instructorSampleOrders.data;

export const getInstructorSampleOrdersStatus = (state: StoreState) => state.myAccountState.instructorSampleOrders.status;
